<template>
  <custom-dialog
    :show="show"
    :title="title"
    @toggleShow="handleClose"
    :appendToBody="true"
    width="50%"
  >
    <div class="flex form" slot="main">
      <el-form
        style="max-height: 500px"
        ref="form"
        :rules="rules"
        :model="form"
        label-width="128px"
        label-position="right"
      >
        <el-form-item
          :label="$t(item.label) + '：'"
          v-for="item in currentFormItem"
          :key="item.key"
          :prop="item.key"
        >
          <template v-if="item.inputType == 'cascader'">
            <el-cascader
              v-model="form[item.key]"
              :options="item.options"
              @change="handleOrgChange"
            ></el-cascader>
          </template>

          <template v-else-if="item.inputType == 'textarea'">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="form.description"
            >
            </el-input>
          </template>
          <template v-else-if="item.inputType == 'tree'">
            <el-input
              size="small"
              style="width: 268px"
              placeholder="输入关键字进行过滤"
              v-model="form.keyword">
            </el-input>
            <el-tree
              :filter-node-method="filterNode"
              :data="menudata"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-expanded-keys="[]"
              :default-checked-keys="checkedKeys"
              :props="defaultProps"
              ref="menuTree"
              @check="handleCheckChange"
            >
            </el-tree>
          </template>
          <template v-else-if="item.inputType == 'keychange'">
            <el-input
              size="small"
              style="width: 268px"
              v-model="form[item.key]"
              :placeholder="$t(item.label)"
            ></el-input>
          </template>
          <template v-else>
            <el-input
              size="small"
              @blur="orgIsExist"
              style="width: 268px"
              v-model="form[item.key]"
              :placeholder="$t(item.label)"
            ></el-input>
          </template>
        </el-form-item>
      </el-form>
    </div>

    <div class="flex btns" slot="footer">
      <el-button
        type="success"
        class="btn cancel"
        size="small"
        @click="handleClose()"
      >
        {{ $t("public.close") }}
      </el-button>
      <el-button type="primary" class="btn save" size="small" @click="save">
        {{ $t("public.save") }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import {
  queryMemu,
  addRole,
  editRole
} from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "EditSn",
  components: {
    CustomDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editOrgState: {
      type: Number,
      default: 1, // 1 新增  2 编辑
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    // 校验账号
    var validateSN = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    return {
      checkedKeys: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      menudata: [],
      formItem: [
        {
          label: "dialog.open.role_name",
          key: "role_name",
          inputType: "input",
        },
        {
          label: "dialog.open.role_describe",
          key: "description",
          inputType: "textarea",
        },
        // {
        //   label: "dialog.open.role_menu_keys",
        //   key: "keyword",
        //   inputType: "keychange",
        // },
        {
          label: "dialog.open.role_menu",
          key: "role_menu",
          inputType: "tree",
        },
      ],
      form: {
        role_name: "",
        description: "",
        role_menu: "",
        keyword: "",
      },
      rules: {
        role_name: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        description: [
          { max: 200, message: "角色说明不能超过200字", trigger: "blur" },
        ],
        role_menu: [
          { required: true, message: "请选择角色权限", trigger: "blur" },
        ]
      },
    };
  },
  computed: {
    title() {
      if (this.editOrgState == 1) {
        // 新增
        return this.$t("dialog.open.add_role");
      } else {
        // 编辑
        return (
          this.$t("dialog.open.edit_role") + "【" + this.rowInfo.org_name + "】"
        );
      }
    },
    currentFormItem() {
      return this.formItem;
    },
  },
  watch: {
    show: {
      handler(val) {
        if (this.editOrgState == 1) {
          this.form = {
            role_name: "",
            description: "",
            role_menu: "",
            keyword: ""
          };
        } else {
          //  此处需要处理上级机构f
          this.form = this.rowInfo;
        }
      },
      deep: true,
    },
    rowInfo: {
      handler(val) {
        // console.log(val, "vvvvv")
        if (val.id) {
          this.form = {
            role_name: val.role_name,
            description: val.role_describe,
            role_menu: val.org_name.menus,
            keyword: ""
          };
          this.checkedKeys = val.org_name.menus
          this.checkKeysNode(this.checkedKeys)
          // console.log(this.form, "fffffffff")
        } 
      },
      deep: true,
    },
    "form.keyword": {
      handler(newV) {
        this.$nextTick(() => {
          // console.log(this.$refs.menuTree, "ttttt")
          this.$refs.menuTree[0].filter(newV); // v-for 循环出来的要加上[0]
        });
      },
      // deep: true,
    },
  },
  mounted(){
    this.getMenu()
  },
  methods: {
    checkKeysNode(node){
      this.$nextTick(()=>{
        // console.log(this.$refs.userTree.setCheckedKeys(node), "tree")
        this.$refs.menuTree[0].setCheckedKeys(node)
      })
    },
    getMenu(){
      queryMemu().then(res=>{
        // console.log(this.generateOptions(res.data), "menuuuuuuu")
        if(res.code == 200){
          this.menudata = this.generateOptions(res.data)
        }
      })
    },
    // 递归处理接口数据
    generateOptions(params) {
      let result = [];
      for (const param of params) {
        if (param.pid == 0) {
          // 判断是否为顶层节点
          let parent = {
            id: param.id,
            label: param.name,
            pid: param.pid
          };
          parent.children = this.getchilds(param.id, params); // 获取子节点
          result.push(parent);
        }
      }
      return result;
    },
    getchilds(value, array) {
      const childs = [];
      for (const arr of array) {
        // 循环获取子节点
        if (arr.pid === value) {
          childs.push({
            id: arr.id,
            label: arr.name,
            pid: arr.pid
          });
        }
      }
      for (const child of childs) {
        // console.log(childs, "sssss")
        // 获取子节点的子节点
        const childscopy = this.getchilds(child.id, array); // 递归获取子节点
        if (childscopy.length > 0) {
          child.children = childscopy;
        }
      }
      return childs;
    },
    handleCheckChange(data, e, l) {
      // console.log(e,l, "ddddddd"); // 可以拿到节点信息
      // console.log(JSON.stringify(e.checkedNodes),"22222")
      this.form.role_menu = e.checkedKeys.concat(e.halfCheckedKeys)
      // this.form.pname = data.label;
      // this.form.id = data.id;
      // this.$refs.tree[0].setCheckedKeys([data.id]);
    },
    filterNode(value, data) {
      // console.log(value, data, "节点过滤");
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    orgIsExist(e) {
      // 判断是否重复
      this.$emit("orgIsExist", e);
    },
    handleOrgChange() {
      //   更换机构
    },
    handleClose(done) {
      this.$emit("toggleShow", false);
      this.$emit("update:rowInfo", {})
      this.checkedKeys = []
      this.$refs.form.clearValidate();
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let param = {
            name: this.form.role_name,
            describe: this.form.description,
            menus: this.form.role_menu
          };
          if(this.rowInfo.id){
            // 编辑
            param.role_id = this.rowInfo.id
            editRole(param).then(res=>{
              if(res.code == 200){
                this.$message.success("编辑角色成功！")
                this.handleClose()
                this.$emit('refush')
              }
            })
          } else {
            // 新增
            addRole(param).then(res=>{
              if(res.code == 200){
                this.$message.success("新增角色成功！")
                this.handleClose()
                this.$emit('refush')
              }
            })
          }
          // 此处判断新增还是编辑
          //   let cusFunc =
          // addThird(param).then((res) => {
          //   if (res.code == 200) {
          //     this.handleClose();
          //     this.$emit("refush");
          //   }
          //   this.$message({
          //     message: res.message,
          //     type: res.code == 200 ? "success" : "error",
          //   });
          // });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  justify-content: center;
  .btn {
    width: 180px;
    height: 32px;
  }
  .save {
    background-color: $main_color;
    border-color: $main_color;
    margin-left: 30px;
  }
  .cancel {
    border-color: $main_color;
    background-color: #fff;
    color: $main_color;
  }
}
.form {
  justify-content: center;
  // max-height: 500px;
  overflow: auto;
  ::v-deep .el-form-item {
    // margin-bottom: 10px;
    display: flex;
    .el-form-item__label {
      font-weight: bold;
    }
    .el-form-item__content {
      flex: 1;
      margin-left: 0 !important;
      .el-cascader {
        width: 100%;
      }
    }
  }
}
</style>
